import { carSafety, carComfort } from '@constants/values/equipment'

const dodatkoweWyposazenieSamochody = { t: 'Dodatkowe wyposażenie', inputs: [
    { t: 'Bezpieczeństwo', type: 'multi-checkbox', name: 'bezpieczenstwo', options: carSafety },
    { t: 'Komfort', type: 'multi-checkbox', name: 'komfort', options: carComfort }
]}

export default dodatkoweWyposazenieSamochody